const $ = require('cash-dom');
const popup = require('./popup');

const Template = {
    // takes innerHTML from the source, replaces all variables
    get: function (source, vars) {
        let html = $(source).html();
        if (typeof (vars) !== 'undefined') {
            $.each(vars, function (search, replacement) {
                html = html.replace(new RegExp("{{" + search + "}}", 'g'), replacement);
            });
        }
        return html;
    },

    // gets template and puts it to the dest
    put: function (source, dest, vars) {
        $(dest).html(Template.get(source, vars));
    },

    popup: function (source, vars, options = {}) {
        let $popupContent = $(Template.get(source, vars));

        $popupContent.find('img.lazy').each(function () {
            $(this)
                .on('load', function () {
                    // TODO check this
                    // $.colorbox.resize();
                })
                .attr('src', $(this).data('src'))
                .removeClass('lazy');
        });

        const popupHtml = $('<div>').append($popupContent).html();

        popup.show(popupHtml, options);

        setTimeout(function () {
            if (typeof applyAloomaTracking !== 'undefined') {
                applyAloomaTracking();
            }
        }, 300);
    }
};

module.exports = Template;
